import axiosApiInstance from './axiosInstance';

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN;

const calendlyService = {
  checkToken: async (advisorId: number) => {
    await axiosApiInstance.get(
      `${baseUrl}/api/v1/calendly/check-token?advisorId=${advisorId}`,
    );
  },
};

export default calendlyService;
